<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Variables</h3></template
      >
      <div><Table /></div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create an SMS Template
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white py-10 px-20 menucontrol-scroll fixed-top">
      <div class="flex justify-around items-start gap-4">
        <div class="w-3/5 flex justify-start">
          <div class="flex items-center justify-end">
            <p class="col-4f text-xl cross mb-0 whitenowrap font-semibold">
              Preview
            </p>
          </div>
          <div class="w-3/4">
            <div class="relative">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/sms.svg"
                alt="sms"
                class="width-sms"
              />
              <div class="absolute top-0 left-0 right-0">
                <div class="width-smss pl-6 pr-6">
                  <div class="flex justify-center h-full items-center">
                    <div class="mb-9rem">
                      <div class="text-center">
                        <small class="text-dark">{{ dateFormat }}</small>
                      </div>
                      <div
                        class="mt-4 rounded-10px bg-e5 wid-mobilesswh py-4 px-6"
                      >
                        <p class="text-dark fsize12">
                          {{
                            smsbody
                              ? smsbody
                              : "Note:You can use dynamic tags to fetch info like names,companies & contact info."
                          }}
                          <br />
                          <a
                            :href="landingSelected"
                            target="_blank"
                            class="col-61"
                            >{{
                              !smsbody && !landingSelected
                                ? "https://projectbrained.app/asjahfo"
                                : landingSelected
                            }}</a
                          >
                        </p>
                      </div>
                      <div class="text-right pt-1">
                        <small class="text-dark">{{ timeFormat }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <p class="fsize12 col-4f">
                Note: The appearence of the text message may vary <br />based on
                the style preference on diffrent device.
              </p>
            </div>
          </div>
        </div>
        <div
          class="bg-white w-2/5 h-530px cust-shadow rounded-10px px-8 pt-8 pb-24 relative"
        >
          <div>
            <div>
              <h6 class="col-4f text-xl mb-1 font-semibold">
                Select Sender ID
                <small> <span class="text-danger">*</span></small>
              </h6>
              <p class="text-8f8f8f fsize12 mb-0">
                Select your sender email ID.
              </p>
              <el-select
                v-model="value"
                placeholder="Select"
                class="w-full mt-2"
                value-key="_id"
              >
                <el-option
                  v-for="item in smsConfig"
                  :key="item._id"
                  :label="item.sender"
                  :value="item._id"
                >
                </el-option>
              </el-select>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ value === "" ? "This Field is required" : "" }}
              </p>
            </div>
            <div class="mt-6">
              <h6 class="col-4f text-xl mb-1 font-semibold">
                Template Name<small><span class="text-danger">*</span></small>
              </h6>

              <el-input
                placeholder="Please input"
                class="mt-2 w-full"
                v-model="name"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{
                  name === "" || name[0].trim() === ""
                    ? "This Field is required"
                    : ""
                }}
              </p>
            </div>
            <div class="mt-6">
              <div class="flex justify-between items-end">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  SMS Body <small><span class="text-danger">*</span></small>
                </h6>
                <!-- <p
                  class="text-sm underline text-primary cursor-pointer"
                  @click="dialogVisible = true"
                >
                  Variable help
                </p> -->
              </div>
              <el-input
                placeholder="Please input"
                class="mt-2 w-full textarea-h100px"
                v-model="smsbody"
                type="textarea"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ smsbody === "" ? "This Field is required" : "" }}
              </p>
            </div>

            <div class="mt-6">
              <h6 class="col-4f text-xl mb-1 font-semibold">Attach a URL</h6>

              <p class="text-8f8f8f fsize12 mb-0">
                Link a specific page or a website you'd like to include in your
                campaignD
              </p>
              <div class="w-full flex mt-3 items-center">
                <div class="w-10/12">
                  <el-select
                    v-model="landingSelected"
                    placeholder="Select"
                    class="w-full"
                    value-key="_id"
                  >
                    <el-option
                      v-for="item in landing"
                      :key="item._id"
                      :label="item.fullURL"
                      :value="item.fullURL"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="w-2/12 flex justify-end">
                  <vs-button
                    v-if="landingSelected !== ''"
                    variant="primary"
                    class="py-3 px-4 font-medium rounded-lg"
                    @click="
                      () => {
                        this.landingSelected = '';
                      }
                    "
                  >
                    <feather-icon
                      icon="XIcon"
                      svgClasses="w-4 h-4"
                      class="text-white"
                    />
                  </vs-button>
                </div>
              </div>

              <!-- <p v-if="submitted == true" class="fsize12 text-danger">
                {{ landingSelected === "" ? "This Field is required" : "" }}
              </p> -->
            </div>
          </div>
          <div class="absolute bottom-0 margin-niche right-0">
            <div class="cursor-pointer">
              <!-- <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
                @click="handleClick('marcom-SMSTemplate-Complete')"
              /> -->
              <div class="bg-primary w-24 h-24 rounded-full">
                <div
                  class="flex justify-center items-center w-24 h-24"
                  @click="handleClick('marcom-Templates')"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";
import Table from "@/views/adminPanel/pages/variables/components/Table.vue";
import { mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    Table,
  },
  data() {
    return {
      FeatherIconsmsbody: "",
      dialogVisible: false,
      smsConfig: [],
      value: "",
      smsbody: "",
      url: "",
      projectId: "",
      template_id: "",
      name: "",
      landingSelected: "",
      landing: "",
      submitted: false,
      clickedOnce: true,
    };
  },
  computed: {
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("marcom", ["taskListUsers"]),
    ...mapState("template", ["valueTemplate"]),
    dateFormat() {
      return moment().format("ddd, MMMM DD");
    },
    timeFormat() {
      return moment().format("HH:mm a");
    },
  },
  methods: {
    async handleClick(name) {
      this.submitted = true;
      if (this.value !== "" && this.smsbody !== "" && this.name !== "") {
        let payload = {
          projectID: this.selectedProject._id,
          displayName: this.selectedProject.displayName,
          smsBody: this.smsbody,
          name: this.name,
          url: this.landingSelected,
          sender_id: this.value,
          projectName: this.selectedProject.projectName,
          user: this.taskListUsers.PM[0]._id,
        };
        if (this.clickedOnce) {
          await this.$store.dispatch("smsCampaign/createSmsTemplate", payload);
          this.clickedOnce = false;
        }
        const res = await this.$swal({
          icon: "success",
          title: "SMS Template Created Successfully",
          showConfirmButton: true,
        });
        console.log(res, "RES");
        if (res.isConfirmed) {
          let data = "SMS";
          this.$store.commit("template/TEMPLATE_VALUE_STORE", data);
          this.$router.push({ name: name });
        }
      }
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.name = this.name ? this.name.trimStart() : "";
        this.smsbody = this.smsbody ? this.smsbody.trimStart() : "";
      });
    },

    async getSmsConfig() {
      let data = await this.$store.dispatch("smsCampaign/getSmsConfig", {
        projectId: this.selectedProject._id,
      });
      this.smsConfig = data;
      console.log(data);
    },
    async getProjectId() {
      let data = await this.$store.dispatch("user/selectedProject");
      this.selectedProject = data;
      console.log(this.selectedProject);
    },
    async getAll() {
      let data = await this.$store.dispatch("landingPage/getAllLandingPage");
      this.landing = data.data.data;
    },
  },

  async mounted() {
    this.getSmsConfig();
    this.getAll();
    console.log(this.selectedProject._id);
  },
  watch: {
    name(val) {
      this.whitespaceRemove();
    },
    smsBody() {
      this.whitespaceRemove();
    },
  },
};
</script>
